const routes = {
  path: "/facturas",
  name: "Facturas",
  component: () => import("./views/Facturas.vue"),
  meta: { requiresAuth: true },
  props: (route) => Object.assign({}, route.query, route.params),
};

export default routes;
